import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { borderRadius } from "../../theme/tokens";

// tailwind-merge only knows Tailwind's built-in radius names, so without this
// `cn("rounded-control", "rounded-full")` would keep both classes instead of
// letting the override win. Colour and shadow tokens already merge correctly.
const twMerge = extendTailwindMerge({
  extend: { theme: { borderRadius: Object.keys(borderRadius) } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
